export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = '2394aa578e5be0abf600ec650635180ca3241293';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};